import * as React from 'react';
import { BaseBlockView } from '../base-block.view';
import { SocialShareButtonsModel } from '../../../model/block';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { FacebookShareButton } from '../../social-share-buttons/facebook-share-button/facebook-share-button';
import { LinkedInShareButton } from '../../social-share-buttons/linked-in-share-button/linked-in-share-button';
import { TwitterShareButton } from '../../social-share-buttons/twitter-share-button/twitter-share-button';
import { MailShareButton } from '../../social-share-buttons/mail-share-button/mail-share-button';
import styled from 'styled-components';
import { draftToString } from '../../../util/draft/draft-to-string.util';
import { SocialShareButtonsEnum } from '../../../enum/block/social-share-buttons.enum';
import { invariant } from '../../../util/debug/invariant.util';
import { getCenterOfPageStyle } from '../../../util/style/get-center-of-page-style';

const SocialShareButtonsViewWrapper = styled.div`
  display:flex;
  justify-content: space-around;
  padding-top: 25px;
  padding-bottom: 25px;
  ${getCenterOfPageStyle()}
`;

@inject('state')
@observer
export class SocialShareButtonsView extends BaseBlockView<SocialShareButtonsModel, IInjectedProps> {
  render() {
    const {content} = this.props;
    const {mailButton, twitterButton, facebookButton, linkedInButton} = content;
    return (
      <SocialShareButtonsViewWrapper>
        {content.socialButtonsOrder.map((socialButtonId: SocialShareButtonsEnum) => {
          switch (socialButtonId) {
            case SocialShareButtonsEnum.Facebook:
              return <FacebookShareButton
                key={socialButtonId}
                size={facebookButton.size}
                showButton={facebookButton.showButton}
              />;
            case SocialShareButtonsEnum.Twitter:
              return <TwitterShareButton
                key={socialButtonId}
                size={twitterButton.size}
                showButton={twitterButton.showButton}
                via={draftToString(twitterButton.via, this.props.state)}
                hashTags={twitterButton.hashTags}
                inviteText={draftToString(twitterButton.inviteText, this.props.state)}
              />;
            case SocialShareButtonsEnum.LinkedIn:
              return <LinkedInShareButton
                key={socialButtonId}
                size={linkedInButton.size}
                title={draftToString(linkedInButton.title, this.props.state)}
                description={draftToString(linkedInButton.description, this.props.state)}
                showButton={linkedInButton.showButton}
              />;
            case SocialShareButtonsEnum.Mail:
              return <MailShareButton
                size={mailButton.size}
                key={socialButtonId}
                showButton={mailButton.showButton}
                subject={draftToString(mailButton.subject, this.props.state)}
                body={draftToString(mailButton.body, this.props.state)}
              />;
          }
          invariant(false, 'Social share button type is not defined', socialButtonId);
        })}
      </SocialShareButtonsViewWrapper>
    );
  }
}
